import React from 'react';
import TransportationWidget from 'components/widget/transportation';
import ILSchools from 'components/widget/heb-schools';
import BuildingPermitWidget from 'components/widget/building-permit';
import Safety from 'components/widget/safety';
import NewConstructionsWidget from 'components/widget/construction';
import Prices from 'components/widget/prices';
import Nuisances from 'components/widget/nuisances';
import QuietStreets from 'components/widget/quiet-streets';
import NeighborsWidget from 'components/widget/neighbors';
import NeighbourhoodLifeWidget from 'components/widget/neighbourhood-life';
import Trends from 'components/widget/trends';
import { widgetAliases } from 'utils/widgetsConfig';
import { Section as SectionEnum } from '../navigation/subheader/SectionsNavigation';
import { ScrollSpyTarget } from '../scroll-spy';
import PricesDeals from 'components/widget/prices/section';

interface WidgetsMapperOptions {
  isUnitPage?: boolean;
  address?: string;
  hideProjectPrices?: boolean;
}

export const widgets = (widgetAlias: widgetAliases, options?: WidgetsMapperOptions) => {
  const { address, isUnitPage, hideProjectPrices } = options || {};

  const map: Record<widgetAliases, JSX.Element> = {
    transportation: <TransportationWidget />,
    ilSchools: <ILSchools />,
    buildingPermit: <BuildingPermitWidget address={address} />,
    safety: <Safety />,
    newConstructions: <NewConstructionsWidget />,
    madad: null,
    prices: isUnitPage
      ? <Prices />
      : hideProjectPrices ? null : <ScrollSpyTarget targetId={SectionEnum.PRICES}><Prices /></ScrollSpyTarget>,
    nuisances: <Nuisances />,
    neighbors: <NeighborsWidget />,
    neighbourhoodLife: <NeighbourhoodLifeWidget />,
    quietStreets: <QuietStreets />,
    trends: isUnitPage
      ? <Trends />
      : <ScrollSpyTarget targetId={SectionEnum.TRENDS}><Trends /></ScrollSpyTarget>,
    deals: <ScrollSpyTarget targetId={SectionEnum.PRICES_ESTIMATION}><PricesDeals /></ScrollSpyTarget>,
  };

  return map[widgetAlias];
};
